// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if (!window.squareerp) window.squareerp = {};

squareerp.subscribe_to_newsletter = function (opts, btn) {
	return froggy.call({
		type: "POST",
		method: "froggy.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
